import { ButtonHTMLAttributes } from 'react';
import classnames from 'classnames';
import useStyles from './ActionableIcon.styles';

export interface IActionableIconProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Optional JSS class for further styling */
  className?: string;
  menuChoices?: undefined;
}

const ActionableIcon = ({
  children,
  className,
  onClick,
  type = 'button',
  ...rest
}: IActionableIconProps) => {
  const classes = useStyles();
  return (
    <button
      aria-label={type}
      className={classnames(classes.actionableIcon, className)}
      onClick={onClick}
      // eslint-disable-next-line react/button-has-type
      type={type}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      {typeof children === 'function' ? children() : children}
    </button>
  );
};

export default ActionableIcon;
